<template>
	<div class="holder">
		<div class="label text-sm mb-1 opacity-50" v-if="label">
			{{ label }}
		</div>

		<div class="ui-color flex items-center" @click="show = true">
			<div class="w-4 h-4 rounded-sm mr-2" :style="`background-color: ${value};`" />
			<p class="m-0 text-sm">{{ value }}</p>
		</div>

		<template v-if="show">
			<div class="wrap" @click.prevent="save" />
			<ColorPicker class="picker" :value="value" @input="update" />
		</template>
	</div>
</template>

<script>
import { Chrome } from 'vue-color'

export default {
	name: 'uiColorPicker',
	components: {
		ColorPicker: Chrome,
	},
	props: {
		label: String,
		value: {
			type: String,
			default: '#ffffff',
		},
	},
	data() {
		return {
			show: false,
		}
	},
	created() {
		this.inner = this.value
	},
	watch: {
		value(nv) {
			this.inner = nv
		},
	},
	methods: {
		update(e) {
			this.inner = e.hex
			this.$emit('input', this.inner)
		},
		save() {
			this.$emit('save', this.inner)
			this.show = false
		},
	},
}
</script>

<style lang="less" scoped>
@import '../../assets/app.less';

.holder {
	width: 100%;
	display: block;
}

.ui-color {
	flex-shrink: 0;
	width: fit-content;
	height: 50px;
	padding: 0 20px;
	background: @grey;
	border-radius: 10px;
	line-height: 50px;
	text-align: center;
	cursor: pointer;
}

.picker {
	transform: translateX(-35%);
	position: absolute;
	z-index: 22;
}

.wrap {
	width: 100%;
	height: 100%;
	position: fixed;
	z-index: 20;
	left: 0;
	top: 0;
}
</style>
